import { render, staticRenderFns } from "./SetupBrandCard.vue?vue&type=template&id=55bd6cc4&scoped=true"
import script from "./SetupBrandCard.vue?vue&type=script&lang=js"
export * from "./SetupBrandCard.vue?vue&type=script&lang=js"
import style0 from "./SetupBrandCard.vue?vue&type=style&index=0&id=55bd6cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd6cc4",
  null
  
)

export default component.exports